import { makeAPICall } from '@gokwik/utilities'
import APIEndPoints from '@library/utilities/constants/apiEndpoints'
import { fetchUserDetails } from '@store/user'
import { message } from 'gokwik-ui-kit'
import { useAppDispatch } from '@library/utilities/hooks'
import GstIcon from '@library/images/icons/kyc/gst-icon.svg'
import PanIcon from '@library/images/icons/kyc/pan-icon.svg'
import CancelledChequeIcon from '@library/images/icons/kyc/cancelled-cheque-icon.svg'
import AadharIcon from '@library/images/icons/kyc/aadhar-icon.svg'
import AayushIcon from '@library/images/icons/kyc/aayush-icon.svg'
import BisIcon from '@library/images/icons/kyc/bis-icon.svg'
import BoardResolutionIcon from '@library/images/icons/kyc/board-resolution-icon.svg'
import BusinessConstitutionIcon from '@library/images/icons/kyc/business-constitution-icon.svg'
import FssaiIcon from '@library/images/icons/kyc/fssai-icon.svg'
import PanBusinessIcon from '@library/images/icons/kyc/pan-business-icon.svg'
import UboIcon from '@library/images/icons/kyc/ubo-icon.svg'
import { handleError } from '@library/utilities/helpers/handleError'

export const pushResponseToMerchantConfig = async (payload: any, mid: string, callBack: () => void) => {
    try {
        const dispatch = useAppDispatch()
        const response = await makeAPICall({
            method: 'post',
            url: process.env.REACT_APP_BASE_URL + APIEndPoints.updateMerchantOnboardingStatus + mid,
            payload: payload,
            skipLoader: true,
        })

        if (response?.status === 200) {
            callBack()
            dispatch(fetchUserDetails())
        } else {
            message.error('Something went wrong. Try again!')
        }
    } catch (error) {
        message.error('Something went wrong. Try again!')
    }
}

export const getPrevQuestionStatus = (state) => {
    switch (state) {
        case 'pre_kyc_entity_type':
            return 'kyc_viewed'
        case 'pre_kyc_business_category':
            return 'pre_kyc_entity_type'
        default:
            return 'kyc_viewed'
    }
}

export const getDocIconByName = (name) => {
    switch (name) {
        case 'address_proof_front_page':
            return GstIcon
        case 'address_proof_back_page':
            return GstIcon
        case 'pan_card':
            return PanBusinessIcon
        case 'aus_pan_card':
            return PanIcon
        case 'cancelled_cheque':
            return CancelledChequeIcon
        case 'aus_aadhar_card_front_page':
            return AadharIcon
        case 'aus_aadhar_card_back_page':
            return AadharIcon
        case 'aus_board_resolution_authorizing':
            return BoardResolutionIcon
        case 'business_registration_proof':
            return BusinessConstitutionIcon
        case 'ayurvedic_license':
            return AayushIcon
        case 'bis_license':
            return BisIcon
        case 'fssai_license':
            return FssaiIcon
        case 'ubo_declaration':
            return UboIcon
        default:
            return GstIcon
    }
}

export const getKeyForLabel = (label) => {
    switch (label) {
        case 'Do You Sell Edible Food Products?':
            return 'sell_edible_food_products'
        case 'Do You Sell Ayurvedic Products?':
            return 'sell_ayurvedic_products'
        case 'Do You Sell Gold and Silver Products?':
            return 'sell_gold_and_silver_products'
        default:
            return ''
    }
}

export const getKycDoc = async (name, setVisible, setDocumentUrl) => {
    await makeAPICall({
        method: 'post',
        url: process.env.REACT_APP_BASE_URL + APIEndPoints.getKycDocument,
        payload: {
            file_name: name,
        },
    }).then((res) => {
        const downloadUrl = res.data.data.download_url
        setDocumentUrl(downloadUrl)
        setVisible(true)
    })
}

const beforeUpload = (item, file) => {
    const isLt5M = file.size / 1024 / 1024 < 5
    const uploadedMimeType = file?.type
    const uploadFormat = uploadedMimeType.split('/')[1]
    const allowedFileTypes = item?.other_details?.allowed_format?.split(', ')
    const isAllowedFormat = allowedFileTypes?.includes(uploadFormat)

    if (!isAllowedFormat && allowedFileTypes !== undefined) {
        message.error(`You can only upload files of types: ${allowedFileTypes}`)
        return false
    } else if (!isLt5M) {
        message.error('Image must smaller than 5MB!')
        return false
    }
    return true
}

const updateKycDoc = async (name, getDocumentList) => {
    try {
        await makeAPICall({
            method: 'post',
            url: process.env.REACT_APP_BASE_URL + APIEndPoints.updateKycDocument,
            payload: {
                file_name: name,
            },
        }).then((res) => {
            if (res.data.status_code === 200) {
                message.success(res.data?.data || 'Document uploaded successfully')
                getDocumentList()
            }
        })
    } catch (err) {
        handleError(err)
    }
}

export const customRequest = async (
    { file, onSuccess, onError },
    item,
    getDocumentList,
    callback,
    errorCallback = () => {},
) => {
    // onSuccess('ok')

    if (!beforeUpload(item, file)) {
        onError('ok')
        return
    }
    // Upload file
    await fetch(item.upload_url, {
        method: 'PUT',
        body: file,
    }).then((res) => {
        if (res?.status === 200) {
            onSuccess('ok')
            callback()
            updateKycDoc(item?.name, getDocumentList)
        } else {
            message.error('Upload failed! Please retry.')
            errorCallback()
            onError('Upload failed!')
            return
        }
    })
}

export const getStepFromStatus = (status) => {
    switch (status) {
        case 'kyc_viewed':
            return 0
        case 'pre_kyc_entity_type':
            return 0
        case 'pre_kyc_business_category':
            return 0
        case 'kyc_document_upload':
            return 1
        case 'kyc_review_submit':
            return 2
        case 'kyc_cpv_completed':
            return 2
        case 'kyc_verification_pending':
            return 2
        case 'kyc_verification_failed':
            return 2
        case 'kyc_completed':
            return 2
        default:
            return -1 // Default case if none of the above matches
    }
}
